import { render, staticRenderFns } from "./admin.view.vue?vue&type=template&id=8303f794&"
import script from "./admin.view.ts?vue&type=script&lang=js&"
export * from "./admin.view.ts?vue&type=script&lang=js&"
import style0 from "./admin.view.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports